import { DocumentFormData } from '../../lib/documentForm.utils';

export const DOCUMENT_FORM_RESPONSE_ERROR = 'Uventet respons fra serveren. Prøv igjen senere.';
export const DOCUMENT_FORM_VALIDATION_ERROR =
  'Det oppstod en feil ved validering av skjemaet. Vennligst sjekk at alle felter er fylt ut korrekt.';
export const UNKNOWN_DOCUMENT_FORM_ERROR = 'Det oppstod en ukjent feil. Prøv igjen senere.';

export const getStoredValidationError = (data?: DocumentFormData): string | undefined => {
  const validationError = data?.validationError;

  return typeof validationError === 'string' ? validationError : undefined;
};

export const removeStoredValidationError = (data: DocumentFormData): DocumentFormData => {
  const restFormData = { ...data };
  delete restFormData.validationError;

  return restFormData;
};
